
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import CircleTitle from "@/components/base/table/header/CircleTitle.vue";
import LineTitle from "@/components/base/table/header/LineTitle.vue";
import Header from "@/components/base/table/header/TitleHeader.vue";
import Search from "@/components/semantics/TempHomeSearch.vue";
import PolicyTable from "@/components/base/table/body/TableTextDecoration.vue";
import ProjectTable from "@/components/base/table/body/CalendarSection.vue";
import ToolTable from "@/components/base/table/body/TableImg.vue";
import PublicyTable from "@/components/base/table/body/TableEl.vue";
import MediaTable from "@/components/base/table/body/TableMedia.vue";
import { Loading } from "element-ui";
import { Action, Getter, State } from "vuex-class";
import config from "@/config";
import {
  deepClone,
  removeHTMLTag,
  getParentArea,
  getAreaDepartmentByLastCode,
} from "@/common/utils";
import { getBaseInfo } from "@/common/cookie";
import { pageViewUnit } from "@/config";
@Component({
  name: "Home",
  components: {
    Header, // text-header
    Search, // search-bar
    PolicyTable, // text-table
    ProjectTable,
    PublicyTable,
    ToolTable,
    MediaTable,
    CircleTitle,
    LineTitle,
  },
})
export default class Home extends Vue {
  @Action("policy/getPolicyList") private getPolicy: any;
  @Action("policy/getApplyList") private getApplyList: any;
  @Action("policy/getPublicyPolicy") private getPublicyPolicy: any;
  @State("directCityList") private directCityList: any;
  @Getter("cityName") private cityName: any;
  @Getter("provinceId") private provinceId: any;
  @Getter("cityId") private cityId: any;
  @Action("policy/getMediaList") getMediaList: any;
  mediaData: any = [];
  active = 0;
  btnList: Array<any> = ["新乡市", "河南省", "全部"];
  tableData: any = [];
  loading = false;
  areaOption = this.$root.$data.areaOption;
  // tableData
  policyData: any = [];
  projectData: any = [];
  publicyData: any = [];
  newPublicyData: any = [];
  // loading
  loading_policy = false;
  loading_project = false;
  toolData = [
    {
      src: require("@images/icon/tool_service_0.png"),
      text: "高新技术企业认定诊断工具",
      path: "/pcm/verify",
      tag: "享政策补贴 税收减免",
    },
    {
      src: require("@images/icon/tool_service_1.png"),
      text: "研发费用加计扣除",
      path: "/pcm/productSale",
      tag: "一键评测 享税收优惠",
    },
    {
      src: require("@images/icon/tool_service_2.png"),
      text: "重点软件企业诊断工具",
      path: "/pcm/tax",
      tag: "精准诊断 享税率优惠",
    },
  ];
  loading_publicy = false;
  created() {
    this.setData();
    this.getData();
  }
  async setData() {}
  /**
   * ajax
   */
  getData() {
    this.getPolicyList(this.active);
    this.getProjectList();
    this.getPublicyList();
    this.getNewPublicyList();
    this.getMediaData();
  }
  async getMediaData() {
    let options = {
      current: 1,
      addressCodeList: [
        "410000",
        "410700",
        "410704",
        "410726",
        "410727",
        "410728",
        "410711",
        "410724",
        "410702",
        "410725",
        "410703",
        "410773",
        "410721",
        "410781",
        "410782",
        "410771",
        "410772",
      ],
      size: 8,
      interpretationType: "漫画解读",
      listType: 1,
    };
    const res = await this.getMediaList(options);
    const { code, data, msg } = res;
    if (code === 0 && data) {
      const { records, total, pages } = data;
      this.mediaData = records.map((item: any) => {
        if (!item.withPicturesUrl) {
          item.withPicturesUrl =
            "http://10.110.14.75:12930/zst/user/file/getPathToStream?pathUrl=L3pzdC8yMDIxMDQvMDQvMjAyMTA0MDkxMzQ1MzItVzAyMDIwMTIwNTM5MDk2Njg5NTkzMC5wbmc%3D";
        } else {
          const baseURL =
            process.env.NODE_ENV === "development"
              ? config.basicUrl
              : `${location.origin}/`;
          item.withPicturesUrl = item.withPicturesUrl
            ? item.withPicturesUrl.split(",")[0]
            : "";
          let src = `${baseURL}zst/user/file/getPathToStream?pathUrl=${item.withPicturesUrl}`;
          item.withPicturesUrl = src;
        }
        return item;
      });
    }
    this.loading = false;
  }
  // policy
  async getPolicyList(type: any) {
    // 0-city|1-国家|2-全部
    this.loading_policy = true;
    const allArea: any = [];
    const tempAreaOption = deepClone(this.areaOption);
    allArea.push("410000");
    allArea.push(String("410700"));
    const tempArea = tempAreaOption.filter((province: any) => {
      province.children = province.children
        .filter((city: any) => {
          const provinceItem: any = getParentArea(this.areaOption, city.value);
          const provinceId = provinceItem ? provinceItem.value : provinceItem;
          return city.value === "410700" || provinceId === "410700";
        })
        .map((city: any) => {
          city.children.map((area: any) => {
            allArea.push(area.value);
            return area;
          });
          return city;
        });
      return province.value === "410000";
    });
    const options: any = {
      current: 1,
      size: 8,
      // addressCode: this.cityId,
    };
    switch (type) {
      case 0:
        options.addressCode = "410700";
        break;
      case 1:
        options.addressCode = "410000";
        break;
      case 2:
        options.addressCodeList = allArea;
        break;
    }
    setTimeout(() => {
      this.loading_policy = false;
    }, 30000);
    this.getPolicy(options)
      .then((res: any) => {
        const { code, data, msg } = res;

        if (code === 0) {
          const { records } = data;
          this.policyData = records.map((policy: any) => {
            const { title, releaseDate: date, id } = policy;
            return {
              id,
              title,
              date,
            };
          });
          this.loading_policy = false;
          return records;
        }
      })
      .catch((err: any) => err);
  }
  async getProjectList() {
    const options: any = {
      current: 1,
      size: 4,
      // addressCodeList: [
      // 	"410000",
      // 	"410700",
      // 	"410704",
      // 	"410726",
      // 	"410727",
      // 	"410728",
      // 	"410711",
      // 	"410724",
      // 	"410702",
      // 	"410725",
      // 	"410703",
      // 	"410773",
      // 	"410721",
      // 	"410781",
      // 	"410782",
      // 	"410771",
      // 	"410772"
      // ],
      addressCode: "410700",
      listType: 0,
      sort: "热度",
    };

    this.loading_project = true;
    setTimeout(() => {
      this.loading_project = false;
    }, 30000);
    this.getApplyList(options)
      .then((res: any) => {
        const { code, data, msg } = res;

        if (code === 0) {
          this.loading = false;
          const { total, records } = data;
          this.projectData = records.map(
            ({
              labels,
              department,
              gmtCreate,
              gmtEnd,
              dispatchDirection,
              supportAmount,
              ...item
            }: any) => {
              const currentDate = new Date().getTime();
              const releasedDate: any = gmtCreate
                ? new Date(gmtCreate).getTime()
                : null;
              const deadDate: any = gmtEnd ? new Date(gmtEnd).getTime() : null;
              const depart = department.departmentName || null;
              const title = `${item.title}(${dispatchDirection})`;
              const money = `${
                supportAmount ? (supportAmount / 10000).toFixed(0) : 0
              }万元`;
              delete item.title;
              let state = "";
              if (gmtCreate && currentDate) {
                if (currentDate > releasedDate) {
                  state = "兑现中";
                } else {
                  state = "未开始";
                }
                if (deadDate && currentDate > deadDate) {
                  state = "已截止";
                }
              }
              const label =
                labels.indexOf(",") > 0
                  ? labels.split(",")
                  : labels.split("，");
              return {
                title,
                depart,
                tags: [money, label.length > 0 ? label[0] : null, state],
                ...item,
              };
            }
          );
          // this.total = policy_arr.length;
          this.loading_project = false;
          return records;
        }
      })
      .catch((err: any) => err);
  }
  async getPublicyList() {
    const provinceItem: any = getParentArea(this.areaOption, this.cityId);
    const provinceId = provinceItem ? provinceItem.value : provinceItem;
    const allArea: any = [];
    const tempAreaOption = deepClone(this.areaOption);
    allArea.push(provinceId);
    allArea.push(String(this.cityId));
    const tempArea = tempAreaOption.filter((province: any) => {
      province.children = province.children
        .filter((city: any) => {
          const provinceItem: any = getParentArea(this.areaOption, city.value);
          const provinceId = provinceItem ? provinceItem.value : provinceItem;
          return city.value === this.cityId || provinceId === this.cityId;
        })
        .map((city: any) => {
          city.children.map((area: any) => {
            allArea.push(area.value);
            return area;
          });
          return city;
        });
      return province.value === provinceId;
    });
    const options: any = {
      current: 1,
      size: 5,
      addressCodeList: allArea,
      sort: "热度",
    };
    this.loading_publicy = true;
    setTimeout(() => {
      this.loading_publicy = false;
    }, 30000);
    this.getPublicyPolicy(options)
      .then((res: any) => {
        this.loading_publicy = false;
        const { code, data, msg } = res;

        if (code === 0) {
          const { records } = data;
          this.publicyData = records.map(
            ({
              addressCode,
              content,
              releaseDate,
              department,
              id,
              title,
              deadline,
              pageView,
            }: any) => {
              const release_date = new Date(releaseDate);
              const dead_date = new Date(deadline);
              const current_date = new Date();
              let stater = 0;
              if (current_date.getTime() < release_date.getTime()) {
                stater = 0;
                // not publish
              } else if (current_date.getTime() > dead_date.getTime()) {
                // deadline
                stater = 2;
              } else {
                stater = 1;
              }
              return {
                addressCode,
                content,
                releaseDate,
                department,
                id,
                title,
                stater,
                pageView: pageView + pageViewUnit,
              };
            }
          );
          return records;
        }
      })
      .catch((err: any) => err);
  }
  async getNewPublicyList() {
    const provinceItem: any = getParentArea(this.areaOption, this.cityId);
    const provinceId = provinceItem ? provinceItem.value : provinceItem;
    const allArea: any = [];
    const tempAreaOption = deepClone(this.areaOption);
    allArea.push(provinceId);
    allArea.push(String(this.cityId));
    const tempArea = tempAreaOption.filter((province: any) => {
      province.children = province.children
        .filter((city: any) => {
          const provinceItem: any = getParentArea(this.areaOption, city.value);
          const provinceId = provinceItem ? provinceItem.value : provinceItem;
          return city.value === this.cityId || provinceId === this.cityId;
        })
        .map((city: any) => {
          city.children.map((area: any) => {
            allArea.push(area.value);
            return area;
          });
          return city;
        });
      return province.value === provinceId;
    });
    const options: any = {
      current: 1,
      size: 2,
      addressCodeList: [
        "410000",
        "410700",
        "410704",
        "410726",
        "410727",
        "410728",
        "410711",
        "410724",
        "410702",
        "410725",
        "410703",
        "410773",
        "410721",
        "410781",
        "410782",
        "410771",
        "410772",
      ],
      sort: null,
    };

    this.getPublicyPolicy(options)
      .then((res: any) => {
        const { code, data, msg } = res;

        if (code === 0) {
          const { records } = data;
          this.newPublicyData = records.map(
            ({
              addressCode,
              lead: htmlContent,
              releaseDate,
              department,
              id,
              title,
              deadline,
              pageView,
            }: any) => {
              const release_date = new Date(releaseDate);
              const dead_date = new Date(deadline);
              const current_date = new Date();
              let stater = 0;
              if (current_date.getTime() < release_date.getTime()) {
                stater = 0;
                // not publish
              } else if (current_date.getTime() > dead_date.getTime()) {
                // deadline
                stater = 2;
              } else {
                stater = 1;
              }
              let content = "";
              if (htmlContent) {
                content = removeHTMLTag(htmlContent);
              }
              return {
                addressCode,
                content,
                releaseDate,
                department,
                id,
                title,
                stater,
                pageView: pageView + pageViewUnit,
              };
            }
          );
          return records;
        }
      })
      .catch((err: any) => err);
  }
  /**
   * handle click
   */
  // policy
  clickPolicyLabel({ title, pubDate, id: policyId }: any) {
    this.$router.push({
      path: "/detail/policy",
      query: {
        policyId,
      },
    });
  }
  clickPublicyLabel({ id: informId }: any) {
    // to Publicy detail
    this.$router.push({
      path: "/detail/inform",
      query: { informId },
    });
  }
  clickPolicyBtn(index: any) {
    this.active = index;
    switch (index) {
      case 0:
        this.getPolicyList(0);
        break;
      case 1:
        this.getPolicyList(1);
        break;
      case 2:
        this.getPolicyList(2);
        break;
      default:
        this.getPolicyList(0);
        break;
    }
  }
  clickPolicyMore() {
    // this.$router.push({ path: "/pcm/policy" });
  }
  // project
  clickProjectLabel({ did: directionId, id: projectId }: any) {
    this.$router.push({
      path: "/detail/apply",
      query: {
        directionId,
        projectId,
      },
    });
  }
  clickPublicyMore() {
    this.$router.push({
      path: "/pcm/inform",
    });
  }
  clickProjectMore() {
    this.$router.push({ path: "/pcm/apply" });
  }
  @Watch("cityName")
  handleCityChange(newValue: any, oldValue: any) {
    // const directCityList = ["北京市",  ];
    // if(directCityList.includes(newValue)&&btnLength===3) {
    //   tempArr[1] = null;
    // }
    // tempArr[0] = newValue;
    this.setData();
    this.getData();
  }
}
